import {
  Crosshair,
  Zap,
  ShieldCheck,
  Map,
  TrendingUp,
  Target,
  Bell,
  BarChart3,
} from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const ENGINES = [
  { icon: Crosshair, title: "Position Engine", desc: "Provides structured context for where price is located." },
  { icon: Zap, title: "Event Engine", desc: "Identifies qualifying P.E.E. market events." },
  { icon: ShieldCheck, title: "Validation Engine", desc: "Evaluates the market response after the event." },
  { icon: Map, title: "Trade Map", desc: "Maps Entry, Stop Loss, TP1, and TP2." },
  { icon: TrendingUp, title: "Trend Context", desc: "Provides additional information about trend state and health." },
  { icon: Target, title: "TP / SL Management", desc: "Tracks trade progression and target conditions." },
  { icon: Bell, title: "Alert Engine", desc: "Keeps Executors informed as trade status changes." },
  { icon: BarChart3, title: "P.E.E. Analytics", desc: "Measures execution performance over time." },
];

export default function Intelligence() {
  return (
    <section id="pee-os" data-testid="intelligence-section" className="border-t border-line bg-[#070809] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="03 — The System"
          testid="intelligence-heading"
          title={
            <>
              Intelligence built
              <br />
              for <span className="glow-text-neon text-neon">execution.</span>
            </>
          }
        />
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {ENGINES.map((e, i) => (
            <Reveal key={e.title} delay={0.06 * i} className="h-full">
              <div
                data-testid={`engine-card-${i}`}
                className="group h-full rounded-lg border border-line bg-charcoal p-6 transition-colors duration-500 hover:border-neon/45"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-md border border-line bg-ink transition-colors duration-500 group-hover:border-neon/50">
                  <e.icon size={17} className="text-neon" />
                </div>
                <h3 className="mt-5 font-mono text-xs font-semibold uppercase tracking-[0.16em] text-white">
                  {e.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-mist">{e.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
